import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { DeveloperGuide } from '@/features/content/Guide';
import { MobileDeveloperGuide } from '@/features/content/mobile/MobileDeveloperGuide';

export const Route = createFileRoute('/_app/developer-guide')({ component: DeveloperGuideRoute });

/** Selettore: guida sviluppatore mobile (MaeDesign) vs lettore documenti desktop. */
function DeveloperGuideRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileDeveloperGuide /> : <DeveloperGuide />;
}
